<template>
    <figure :class="rootClasses">
        <svg
                xmlns="http://www.w3.org/2000/svg"
                style="display: block; width: 100%; height: 100%;"
                width="100%"
                height="100%"
                :preserveAspectRatio="aspectRatio"
                :viewBox="viewbox">
            <g :filter="filter">
                <image
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="100%"
                        height="100%"
                        x="0"
                        y="0"
                        filter="url(#svg_black_and_white)"
                        :xlink:href="imageUrl"
                        v-if="isVisible"/>
                <rect width="100%"
                        height="100%"
                        fill="#000"
                        v-else/>
            </g>
        </svg>
    </figure>
</template>
<script>
    import { get } from 'lodash';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import bestPictureMixin from 'framework/mixins/best-picture';
    import interactionObserverMixin from '@dreipol/vue-ui/src/mixins/intersection-observer';
    import { mapState } from 'vuex';
    import { IMAGES } from 'framework/vuex/modules/easter-egg/eggs';

    export default {
        components: {},
        mixins: [bestPictureMixin, interactionObserverMixin, bemMixin('svg-picture-element')],
        props: {
            width: {
                type: Number,
                default: 544,
            },
            height: {
                type: Number,
                default: 388,
            },
            theme: {
                type: String,
                default: 'association',
            },
            alt: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isVisible: window.matchMedia('print'),
            };
        },
        computed: {
            ...mapState('easter-egg', {
                easterEggName: 'name',
            }),
            eggImage() {
                return IMAGES[this.easterEggName];
            },
            filter() {
                return `url(#svg_filter_${ this.theme })`;
            },
            imageUrl() {
                return this.eggImage || get(this.urls.default, Math.ceil(window.devicePixelRatio) - 1, this.urls.default[0]);
            },
            orientation() {
                return this.width > this.height ? 'horizontal' : 'vertical';
            },
            aspectRatio() {
                return this.orientation === 'vertical' ? 'xMidYMax slice' : 'xMaxYMid slice';
            },
            viewbox() {
                return `0 0 ${ this.width } ${ this.height }`;
            },
            rootClasses() {
                return [
                    this.bemRoot,
                    this.bemIf(this.isVisible, 'is-visible', 'is-blurry'),
                ];
            },
        },
        methods: {
            onIntersectEnter() {
                this.isVisible = true;
                this.kill();
            },
            kill() {
                this.unregister(this.$el);
            },
        },
        mounted() {
            this.registerObserver(this.$el, 0.1);
        },
        beforeDestroy() {
            this.kill();
        },
    };
</script>
